module.exports = __webpack_public_path__ + "img/sprite_splash.0a6f096d.svg";